module.exports = __webpack_public_path__ + "img/infrastructure.a57683e7.png";